import { render, staticRenderFns } from "./taskAllocation.vue?vue&type=template&id=da1fc3e4&scoped=true"
import script from "./taskAllocation.vue?vue&type=script&lang=js"
export * from "./taskAllocation.vue?vue&type=script&lang=js"
import style0 from "./taskAllocation.vue?vue&type=style&index=0&id=da1fc3e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1fc3e4",
  null
  
)

export default component.exports